import { CoreAPI, createCommonConnectionMethods } from '@hero/sdk-core';

/** Carrier-facing `Connection` APIs. See customer-sdk equivalent. */
export function createConnectionsAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonConnectionMethods(coreAPI),
  };
}
